import { Controller } from '@hotwired/stimulus';

/**
 * Turns a typed or pasted decimal point or comma into the decimal separator of the page's language
 */
export default class extends Controller {
    connect() {
        this.separator = (1.5).toLocaleString(document.documentElement.lang).charAt(1);
        this.otherSeparator = ',' === this.separator ? '.' : ',';
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.element.addEventListener('keydown', this.handleKeydown);
        this.element.addEventListener('input', this.handleInput);
    }

    disconnect() {
        this.element.removeEventListener('keydown', this.handleKeydown);
        this.element.removeEventListener('input', this.handleInput);
    }

    handleKeydown(event) {
        if (event.key !== this.otherSeparator) {
            return;
        }
        event.preventDefault();

        const input = event.target;
        const start = input.selectionStart;
        input.value = input.value.substring(0, start) + this.separator + input.value.substring(input.selectionEnd);
        input.setSelectionRange(start + 1, start + 1);
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    handleInput(event) {
        const input = event.target;
        if (!input.value.includes(this.otherSeparator)) {
            return;
        }

        const cursorPosition = input.selectionStart;
        input.value = input.value.replaceAll(this.otherSeparator, this.separator);
        input.setSelectionRange(cursorPosition, cursorPosition);
    }
}
